
<div class="modal-dialog" style="max-width: 800px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Edit Accessory</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body" *ngIf="loading">
      <error [error]="error"></error>
      <md-spinner-block></md-spinner-block>
    </div>
    <div class="modal-body" *ngIf="!loading">
      <error [error]="error"></error>
      <form [formGroup]="form">
        <div class="row">
          <div class="form-group col-md-6">
            <label class="required" for="deviceKey">Accessory</label>
            <select class="form-control" id="deviceKey" name="accessorySelection" formControlName="accessorySelection" (change)="accessorySelectionChanged()">
              <option [ngValue]="null"></option>
              <option *ngFor="let c of accessory.availableStandaloneAccessories" [ngValue]="c">{{ c.deviceKey }} - {{ c.productDescription }} ({{ c.productNumber }})</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <label for="serialNumber">Serial Number</label>
            <input class="form-control" id="serialNumber" type="text" name="serialNumber" formControlName="serialNumber" [value]="accessory.serialNumber | uppercase" [(ngModel)]="accessory.serialNumber">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="building">Building</label>
            <input class="form-control" id="building" type="text" name="building" formControlName="building">
          </div>
          <div class="form-group col-md-6">
            <label for="floor">Floor</label>
            <input class="form-control" id="floor" type="text" name="floor" formControlName="floor">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <div class="form-check">
              <input class="form-check-input" type="radio" name="useBulkOrdering" formControlName="useBulkOrdering" autoLinkToLabel (change)="updateBulkOrderData()" [value]="false">
              <label class="form-check-label">Normal Order</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="useBulkOrdering" formControlName="useBulkOrdering" autoLinkToLabel (change)="updateBulkOrderData()" [value]="true" [attr.disabled]="!accessory.availableBulkOrderItems?.length || null">
              <label class="form-check-label">Bulk Order</label>
            </div>
          </div>
          <div class="form-group col-md-6" *ngIf="accessory.useBulkOrdering">
            <label for="bulkOrderAccessoryId">Bulk Order Number</label>
            <select class="form-control" id="bulkOrderAccessoryId" type="text" name="bulkOrderAccessoryId" formControlName="bulkOrderAccessoryId" (change)="updateBulkOrderData()">
              <option value=""></option>
              <option *ngFor="let item of accessory.availableBulkOrderItems" [ngValue]="item.id">{{ item.orderNumber }} ({{ item.orderDate }}) - {{ item.quantityAvailable }}/{{ item.quantity }} available</option>
            </select>
          </div>
          <div class="form-group col-md-6" *ngIf="!accessory.useBulkOrdering">
            <div class="row">
              <div class="form-group col">
                <label for="orderNumber">Order Number</label>
                <input class="form-control" id="orderNumber" type="text" name="orderNumber" formControlName="orderNumber">
              </div>
            </div>
            <div class="row">
              <div class="form-group col">
                <label for="orderDate">Order Date</label>
                <div class="input-group">
                  <input class="form-control" id="orderDate" type="text" name="orderDate" formControlName="orderDate" [value]="form.value.orderDate">
                  <datepicker class="right input-group-append" formControlName="orderDate" name="orderDatePicker" [value]="form.value.orderDate"></datepicker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="save()">Save</button>
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Cancel</button>
    </div>
  </div>
</div>